/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Workout_Vo2maxInputs */

const en_coach_workout_vo2max = /** @type {(inputs: Coach_Workout_Vo2maxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5x3min VO2max`)
};

const de_coach_workout_vo2max = /** @type {(inputs: Coach_Workout_Vo2maxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5x3min VO2max`)
};

/**
* | output |
* | --- |
* | "5x3min VO2max" |
*
* @param {Coach_Workout_Vo2maxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_workout_vo2max = /** @type {((inputs?: Coach_Workout_Vo2maxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Workout_Vo2maxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_workout_vo2max(inputs)
	return de_coach_workout_vo2max(inputs)
});